// add more feature levels in the futer if needed
// dont forget to update values found in UserLogin.js, AccountOwnerLogin.js, & AirwallexForm.js
export const appFeatureLevels = {
    FEATURE_LEVEL_1: 1,
    FEATURE_LEVEL_2: 2,
    FEATURE_LEVEL_3: 3,
};